export default __webpack_public_path__ + "static/media/gallery-wip-emitter_01.afaaab7c.jpg";